import { render } from "./ContractDetailsSection.vue?vue&type=template&id=e23ebb7e"
import script from "./ContractDetailsSection.vue?vue&type=script&lang=js"
export * from "./ContractDetailsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__